<!-- From Honey Badgers Team -->
<ng-container *ngrxLet="rewardContent$ as rewardContent">
    @if (rewardContent) {
        @if (!rewardContent.collapsible) {
            @if (rewardContent?.prizes && rewardContent.prizes.length > 0) {
                <ds-card
                    class="reward-list r-2-columns mb-0 mb-sm-3"
                    [elevated]="dsComponents?.dsCardStatic?.elevated"
                    [variant]="dsComponents?.dsCardStatic?.variant">
                    <div
                        class="reward-list-title"
                        [ngStyle]="{
                            'background-image': 'url(' + rewardContent.titleImage?.image?.src + ')',
                        }">
                        {{ rewardContent.titleImage?.title }}
                    </div>
                    <div class="reward-list-subtitle" [vnDynamicHtml]="rewardContent.titleImage?.parameters?.description"></div>
                    <ul class="reward-content">
                        @for (prize of rewardContent.prizes; track prize; let first = $first) {
                            <li class="r-row" [class.d-flex]="rewardContent.isSingleColumn">
                                <div class="r-col" [ngClass]="{ 'd-flex w-100': rewardContent.isSingleColumn }">
                                    <span
                                        class="text-truncate"
                                        [class.reward-row-value]="first && rewardContent.makeFirstEntryBold"
                                        [vnDynamicHtml]="prize.title"></span>
                                </div>
                                @if (prize.description) {
                                    <div class="r-col">
                                        <span
                                            [class.reward-row-value]="first && rewardContent.makeFirstEntryBold"
                                            [vnDynamicHtml]="prize.description"></span>
                                    </div>
                                }
                            </li>
                        }
                    </ul>
                </ds-card>
            }
        }
        @if (rewardContent.collapsible) {
            @if (rewardContent?.prizes && rewardContent.prizes.length > 0) {
                <ds-card
                    class="r-2-columns mb-4 mb-sm-3"
                    [elevated]="dsComponents?.dsCardStatic?.elevated"
                    [variant]="dsComponents?.dsCardStatic?.variant">
                    @if (rewardContent.titleImage; as titleImage) {
                        <div class="eds-accordion">
                            <div
                                id="{{ titleImage.title }}collapsible_rewards__header"
                                class="collapsible__header theme-up"
                                (click)="rewardsToggle(titleImage.title + 'collapsible_rewards')">
                                <div
                                    class="collapsible-header-title reward-list-title"
                                    [ngStyle]="{ 'background-image': 'url(' + titleImage.image?.src + ')' }">
                                    {{ titleImage.title }}
                                </div>
                            </div>
                            <div id="{{ titleImage.title }}collapsible_rewards__body" class="collapsible__body collapsible-visible">
                                <div>
                                    <div class="mb-0">
                                        <div class="reward-list-subtitle" [vnDynamicHtml]="titleImage.parameters?.description"></div>
                                        <ul class="reward-content">
                                            @for (prize of rewardContent.prizes; track prize; let first = $first) {
                                                <li class="r-row" [class.d-flex]="rewardContent.isSingleColumn">
                                                    <div class="r-col" [ngClass]="{ 'd-flex w-100': rewardContent.isSingleColumn }">
                                                        <span
                                                            class="text-truncate"
                                                            [class.reward-row-value]="first && rewardContent.makeFirstEntryBold"
                                                            [vnDynamicHtml]="prize.title"></span>
                                                    </div>
                                                    @if (prize.description) {
                                                        <div class="r-col">
                                                            <span
                                                                [class.reward-row-value]="first && rewardContent.makeFirstEntryBold"
                                                                [vnDynamicHtml]="prize.description"></span>
                                                        </div>
                                                    }
                                                </li>
                                            }
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                </ds-card>
            }
        }
        @if (rewardContent.additionalPrizes?.length > 0) {
            <ds-card
                class="reward-list reward-list-prize r-2-columns"
                [elevated]="dsRewardPrize?.dsCardStatic?.elevated"
                [variant]="dsRewardPrize?.dsCardStatic?.variant">
                <div class="reward-list-subtitle" [vnDynamicHtml]="rewardContent.titleImage?.parameters?.additionalrewardsdescription"></div>
                <ul class="reward-content">
                    @for (prize of rewardContent.additionalPrizes; track prize; let first = $first) {
                        <li class="r-row" [class.d-flex]="rewardContent.isSingleColumn">
                            <div class="r-col" [ngClass]="{ 'd-flex w-100': rewardContent.isSingleColumn }">
                                <span
                                    class="text-truncate"
                                    [class.reward-row-value]="first && rewardContent.makeFirstEntryBold"
                                    [vnDynamicHtml]="prize.title"></span>
                            </div>
                            @if (prize.description) {
                                <div class="r-col">
                                    <span
                                        [class.reward-row-value]="first && rewardContent.makeFirstEntryBold"
                                        [vnDynamicHtml]="prize.description"></span>
                                </div>
                            }
                        </li>
                    }
                </ul>
            </ds-card>
        }
    }
</ng-container>
